"use strict";
/**
 * Firebase-specific Types and Interfaces
 */
Object.defineProperty(exports, "__esModule", { value: true });
